import PropertyMapping from './property-mapping';
import Types from './types';

export default ({
	PropertyMapping, Types
});
